import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, forwardRef, ViewEncapsulation } from '@angular/core';
import { PrivilegeGroup } from '../models/UserRelationship';
import { AbstractControl, ValidationErrors, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

@Component({
  selector: 'app-privilege-group-dropdown',
  templateUrl: './privilege-group-dropdown.component.html',
  styleUrls: ['./privilege-group-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PrivilegeGroupDropdownComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PrivilegeGroupDropdownComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class PrivilegeGroupDropdownComponent implements OnInit, OnChanges {
  @Input() privilegeGroup: PrivilegeGroup[];
  @Input() filterPlaceHolder: string;
  @Input() defaultLabel: string;
  @Input() maxSelectedLabels: number;
  @Input() readOnly: boolean;
  @Input() privilegeGroupSelected: PrivilegeGroup[];
  @Output() onChange = new EventEmitter<PrivilegeGroup[]>();

  disabled: boolean;
  processing: boolean;
  public onModelChange: (newValue: any) => void = () => { };
  public onModelTouched: (flag: boolean) => void = () => { };

  writeValue(value: any): void {
    this.privilegeGroup = value ? value : this.privilegeGroup;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return c.value ? null : { invalidForm: { valid: false, message: 'Please select an option' } };
  }
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getPrivilegeGroup(selectedPrivilegeGroup: PrivilegeGroup[]): PrivilegeGroup[] {
    selectedPrivilegeGroup.map((privilegeGroup:PrivilegeGroup) => privilegeGroup.Enabled = true);
    return selectedPrivilegeGroup;
  }

  change(newValue: any) {
    newValue = this.getPrivilegeGroup(newValue);
    this.onModelChange(newValue);
    this.onChange.emit(newValue);
  }

  blur() {
    this.onModelTouched(true);
  }

}
